import { Popover } from '@headlessui/react';
import { LOGOUT_PAGE, MY_SETTINGS_PAGE, SERVICES_PAGE, getCoachPageUrl } from 'constants/pages';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import { useGetCurrentUser } from 'hooks/useGetCurrentUser';
import Cog from 'svg/Cog';
import License from 'svg/License';
import LogoutIcon from 'svg/LogoutIcon';
import UserCircle from 'svg/UserCircle';
import Link from 'components/Link';

const CoachDropdown = () => {
  const { user } = useGetCurrentUser();

  const proBadgeJsx = (
    // display hidden for mvp, should be flex
    <div className="absolute -bottom-1 -right-1 hidden  h-3 w-[22px] items-center justify-center rounded-md bg-color-brand-primary px-0.5 pb-0.5 pt-[3px]">
      <div className="absolute inset-[-1px] rounded-[7px] border border-white" />
      <span className="text-[8px] font-medium leading-[7px] text-white">PRO</span>
    </div>
  );

  return (
    <Popover className="relative shrink-0">
      {() => (
        <>
          <Popover.Button className="flex items-center focus:outline-none">
            <div className="relative">
              <img
                src={getProfileImageUrlOrPlaceholder({ path: user?.profileImagePath })}
                alt="Profile"
                className="h-10 w-10 rounded-full object-cover"
              />

              {proBadgeJsx}
            </div>
          </Popover.Button>

          <Popover.Panel className="absolute right-0 z-50 mt-2 w-[15.4rem] rounded-3xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary shadow-[0px_4px_20px_0px_rgba(0,0,0,0.16)] dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary">
            <div className="flex flex-col">
              <div className="border-b border-color-border-card-lightmode dark:border-color-border-card-darkmode">
                <div className="flex items-center gap-3 px-6 py-4">
                  <div className="relative">
                    <img
                      src={getProfileImageUrlOrPlaceholder({ path: user?.profileImagePath })}
                      alt="Profile"
                      className="h-10 w-10 rounded-full object-cover"
                    />

                    {proBadgeJsx}
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[14px] font-medium leading-[1.5] text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                      {user?.fullName}
                    </span>
                    <span className="text-[12px] leading-[16px] text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
                      @{user?.username}
                    </span>
                  </div>
                </div>
              </div>

              {/* Menu items */}
              <div className="flex flex-col gap-4 px-6 py-4">
                <Link
                  href={getCoachPageUrl(user?.username || user?.id)}
                  className="flex items-center gap-2  text-color-text-lightmode-secondary hover:text-color-text-lightmode-primary dark:text-color-text-darkmode-secondary hover:dark:text-color-text-darkmode-primary"
                >
                  <UserCircle className="h-5 w-5 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
                  <span className="typography-product-caption">Listing page</span>
                </Link>

                <Link
                  href={SERVICES_PAGE}
                  className="flex items-center gap-2  text-color-text-lightmode-secondary hover:text-color-text-lightmode-primary dark:text-color-text-darkmode-secondary hover:dark:text-color-text-darkmode-primary"
                >
                  <License className="h-5 w-5 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
                  <span className="typography-product-caption">Coaching services</span>
                </Link>

                <Link
                  href={MY_SETTINGS_PAGE}
                  className="flex items-center gap-2  text-color-text-lightmode-secondary hover:text-color-text-lightmode-primary dark:text-color-text-darkmode-secondary hover:dark:text-color-text-darkmode-primary"
                >
                  <Cog className="h-5 w-5 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon" />
                  <span className="typography-product-caption">Settings</span>
                </Link>
              </div>

              {/* Logout section */}
              <div className="border-t border-color-border-card-lightmode dark:border-color-border-card-darkmode">
                <Link
                  href={LOGOUT_PAGE}
                  className="flex items-center gap-2 px-6 py-4  text-color-brand-primary hover:text-color-brand-primary/80"
                >
                  <LogoutIcon className="h-5 w-5" />
                  <span className="typography-product-caption">Log out</span>
                </Link>
              </div>
            </div>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

export default CoachDropdown;
